import ArticleCategories from 'components/articles/categories'
import { Section } from '@tracklib/kit'

import styles from './articlecategoriesblock.css'

type Props = {
  value: {
    categories: []
  }
}

const ArticleCategoriesBlock = ({ value }: Props): JSX.Element => (
  <Section extraPad className={styles.wrapper}>
    <ArticleCategories categories={value} showAll />
  </Section>
)

export default ArticleCategoriesBlock
